import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { loginReducer } from './reducers/authReducers';
import { employeeCreateReducer, employeeChangeReducer, getEmployeesReducer } from './reducers/employeeReducers';
import { createCustomerReducer, customerSearchReducer, getAllCustomersReducer, getCustomerReducer } from './reducers/customerReducers';
import { createVehicleReducer, vehicleReducer, vehiclesReducer } from './reducers/vehicleReducers';
import { jobTypeCreateReducer, getJobTypesReducer, jobTypeEditReducer, jobTypeDeleteReducer, startJobReducer, getJobsReducer, getJobReducer } from './reducers/jobreducers';

const reducer = combineReducers({
    userAccess: loginReducer,
    createEmployee: employeeCreateReducer,
    changeEmployee: employeeChangeReducer,
    employees: getEmployeesReducer,
    customerSearch: customerSearchReducer,
    vehicle: vehicleReducer,
    vehicles: vehiclesReducer,
    getJobTypes: getJobTypesReducer,
    createJobType: jobTypeCreateReducer,
    editJobType: jobTypeEditReducer,
    deleteJobType: jobTypeDeleteReducer,
    startJob: startJobReducer,
    jobs: getJobsReducer,
    job: getJobReducer,
    customers: getAllCustomersReducer,
    createCustomer: createCustomerReducer,
    createVehicle: createVehicleReducer,
    customer: getCustomerReducer
});

const userInfoFromStorage = localStorage.getItem('access')
    ? JSON.parse(localStorage.getItem('access'))
    : null;

const initialState = {
    userAccess: { userInfo: userInfoFromStorage },
};

const middlware = [thunk];
const store = createStore(
    reducer,
    initialState,
    composeWithDevTools(applyMiddleware(...middlware))
);

export default store;